import React from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import "./ri-sidebar.style.scss";
export default function RISidebar({ steps, selectedStep, setSelectedStep }) {
  const history = useHistory();
  const decideClassName = (obj) => {
    if (selectedStep?.number === obj?.number) {
      return "current-step";
    } else if (obj.number < selectedStep?.number) {
      return "prev-step";
    }
  };
  return (
    <aside className="ri-sidebar-main">
      <img className="dots-up" src={Images.topRightDots} />
      <img className="dots-bottom" src={Images.dotsLeftBottom} />
      <p className="bottom-text">About AcadsHR - Contact US</p>

      <div className="rsm-header">
        <img
          onClick={() => history.push("/")}
          src={Images.mainLogo}
          alt="acads"
        />
      </div>
      <div className="rsm-title-info">
        <h5>Register with us</h5>
        <p>Hire the best crew who guides the student to the brightest sides.</p>
      </div>
      <div className="rsm-steps-wrapper">
        {steps.map((obj) => (
          <Link
            onClick={() => setSelectedStep(obj)}
            to={`/register-institute/${obj.id}`}
          >
            <div className={`step-row ${decideClassName(obj)}`}>
              <button>{obj.number}</button>
              <div>
                <p>Step {obj.number}</p>
                <h5>{obj.title}</h5>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </aside>
  );
}
